import { resolveChatListGroups } from './chatListGroups';

export const CONTACT_EXCLUDED_GROUP_IDS = ['rooms'];

export function resolveContactListGroups(tenantConfig) {
  return resolveChatListGroups(tenantConfig).filter(
    (group) => !CONTACT_EXCLUDED_GROUP_IDS.includes(group.id),
  );
}

export function resolveContactListGroupId(contact) {
  if (contact.listGroupId) return contact.listGroupId;
  if (contact.unit === 'general' || !contact.unit) return 'general';
  return 'units';
}

export function getContactListGroupLabel(tenantConfig, groupId) {
  const group = resolveContactListGroups(tenantConfig).find((item) => item.id === groupId);
  return group?.label || groupId;
}

function sortGeneralContacts(contacts) {
  return [...contacts].sort((a, b) => a.name.localeCompare(b.name, 'sl'));
}

function sortUnitContacts(contacts) {
  return [...contacts].sort((a, b) => {
    const unitCmp = (a.unitName || '').localeCompare(b.unitName || '', 'sl');
    if (unitCmp !== 0) return unitCmp;
    return a.name.localeCompare(b.name, 'sl');
  });
}

export function groupContacts(contacts, tenantConfig) {
  const groups = resolveContactListGroups(tenantConfig);
  const groupMap = new Map(groups.map((group) => [group.id, []]));
  const fallbackGroupId = groupMap.has('general') ? 'general' : groups[0]?.id;

  contacts.forEach((contact) => {
    const groupId = resolveContactListGroupId(contact);
    const targetId = groupMap.has(groupId) ? groupId : fallbackGroupId;
    if (targetId) {
      groupMap.get(targetId).push(contact);
    }
  });

  return groups
    .filter((group) => (groupMap.get(group.id)?.length || 0) > 0)
    .map((group) => ({
      group,
      contacts: group.id === 'units'
        ? sortUnitContacts(groupMap.get(group.id))
        : sortGeneralContacts(groupMap.get(group.id)),
    }));
}
